/* Pagination Component 
-------------------------------------------------*/
import React, { useState, useEffect } from "react";
import '../period-calculator-result/pagination.css'
import Calendar from '../period-calculator-result/Calendar';
import { isMobile } from 'react-device-detect';
import configData from '../../../temp/config';
import { withTranslation } from 'react-i18next';
import ImageComponent from '../../CommonComponent/CommonImage';
// import Symptoms from "./Symptoms";

const defaultProps = {
    initialPage: 1
}

class Pagination extends React.Component {
    constructor(props) {
        super(props);
        this.state = { pager: {} };
    }

    componentWillMount() {
        // set page if items array isn't empty
        if (this.props.items && this.props.items.length) {
            this.setPage(this.props.initialPage);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        // reset page if items array has changed
        if (this.props.items !== prevProps.items) {
            this.setPage(this.props.initialPage);
        }
    }

    setPage(page) {
        var items = this.props.items;
        var pager = this.state.pager;

        if (page < 1 || page > pager.totalPages) {
            return;
        }

        // get new pager object for specified page
        pager = this.getPager(items.length, page);

        // get new page of items from items array
        var pageOfItems = items.slice(pager.startIndex, pager.endIndex + 1);

        // update state
        this.setState({ pager: pager });

        // call change page function in parent component
        this.props.onChangePage(pageOfItems);
    }

    getPager(totalItems, currentPage, pageSize) {
        let itemToBeShown = isMobile ? 1 : 2
        // default to first page
        currentPage = currentPage || 1;

        // default page size is 10
        // This needs to change to show the items on a page
        // for Mobile -- pageSize = pageSize || 1;
        pageSize = pageSize || itemToBeShown;

        // calculate total pages
        var totalPages = Math.ceil(totalItems / pageSize);

        var startPage, endPage;
        if (totalPages <= 10) {
            // less than 10 total pages so show all
            startPage = 1;
            endPage = totalPages;
        } else {
            // more than 10 total pages so calculate start and end pages
            if (currentPage <= 6) {
                startPage = 1;
                endPage = 10;
            } else if (currentPage + 4 >= totalPages) {
                startPage = totalPages - 9;
                endPage = totalPages;
            } else {
                startPage = currentPage - 5;
                endPage = currentPage + 4;
            }
        }

        // calculate start and end item indexes
        var startIndex = (currentPage - 1) * pageSize;
        var endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

        // create an array of pages to ng-repeat in the pager control
        var pages = [...Array((endPage + 1) - startPage).keys()].map(i => startPage + i);

        // return object with all pager properties required by the view
        return {
            totalItems: totalItems,
            currentPage: currentPage,
            pageSize: pageSize,
            totalPages: totalPages,
            startPage: startPage,
            endPage: endPage,
            startIndex: startIndex,
            endIndex: endIndex,
            pages: pages
        };
    }

    increasePage = () => {
        this.setPage(this.state.pager.currentPage + 1)
        this.props.checkSymptomps();
    }

    decreasePage = () => {
        this.setPage(this.state.pager.currentPage - 1)
        this.props.checkSymptomps();
    }

    render() {
        var pager = this.state.pager;

        if (!pager.pages || pager.pages.length <= 1) {
            // don't display pager if there is only 1 page
            return null;
        }

        let inactiveLeftArrow = pager.currentPage === 1;
        let inactiveRightArrow = pager.currentPage === pager.totalPages;

        return (
            <>
                <ul className="pagination-period-calculator">
                    {inactiveLeftArrow ? <li className={pager.currentPage === 1 ? 'disabled' : ''} onClick={() => this.decreasePage()}>
                            <ImageComponent imageIcon={this.props.parentCompData.leftArrowInActiveLogo.value.src} />
                    </li> :
                        <li className={pager.currentPage === 1 ? 'disabled' : ''} onClick={() => this.decreasePage()}>
                                <ImageComponent imageIcon={this.props.parentCompData.leftArrowActiveLogo.value.src} />
                        </li>
                    }

                    {inactiveRightArrow ? <li className={pager.currentPage === pager.totalPages ? 'disabled' : ''} onClick={() => this.increasePage()}>
                            <ImageComponent imageIcon={this.props.parentCompData.rightArrowInActiveLogo.value.src} />
                    </li> :
                        <li className={pager.currentPage === pager.totalPages ? 'disabled' : ''} onClick={() => this.increasePage()}>
                                <ImageComponent imageIcon={this.props.parentCompData.rightArrowActiveLogo.value.src} />
                        </li>
                    }
                </ul>
            </>
        );
    }
}

// Pagination.propTypes = propTypes;
Pagination.defaultProps = defaultProps;


/* App Component 
-------------------------------------------------*/

const SetRemindersPaginator = (props) => {
    // console.log(props.testResult)
    // const [initialCalenderItems, setInitialCalenderItems] = useState(props.result);
    const [initialCalenderItems, setInitialCalenderItems] = useState(props.result.months);
    const [pageOfItems, setPageOfItems] = useState([]);
    const [showEditForm, setShowEditForm] = useState(false);
    const [showSymptoms, setShowSymptoms] = useState(false);
    const [selectedDay, setSelectedDay] = useState({
        day: '',
        month: '',
        year: '',
        moods: {},
        symptoms: {}
    });

    useEffect(() => {
        // setInitialCalenderItems(props.result)
        setInitialCalenderItems(props.result.months)
        setShowSymptoms(false);
        if (isMobile) {
            setShowEditForm(true)
        }
        // setPageOfItems(props.result)
    }, [props.result])

    const onChangePage = (pageOfItems) => {
        // update state with new page of items
        setPageOfItems(pageOfItems)
    }

    const showMainMenu = () => {
        setShowEditForm(false)
        props.showMainMenu();
    }

    const getSymtopms = (day, dateModel, month, year) => {
        // props.getSymtopms(day, dateModel, month, year)
        // let selectedDate = dateModel.filter((item) => {
        //     if (item.day == day) {
        //         return item
        //     }
        // });
        // if (selectedDate.length > 0) {
        //     setSelectedDay({
        //         day, month, year,
        //         moods : selectedDate[0].moods,
        //         symptoms: selectedDate[0].symptoms
        //     })
        //     setShowSymptoms(true)
        // }
        // console.log(month, year)
    }

    const checkSymptomps = () => {
        //props.checkSymptomps();
    }

    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    return (
        <>
            {/* {showEditForm && <div className="recalculate-wrap-period-form">

            <div className="fdlp-mobile">
                    <img src={`${configData.sitecoreApiHost}${props.componentData.datePickerLogo.value.src}`} />
                    <span>{props.componentData.dateSelectionLabel.value}</span> <span>{props.currentMonthCycle.dayValue} {months[props.currentMonthCycle.monthValue]}, {props.currentMonthCycle.yearValue}</span>
                </div>
                <div className="avg-period-mobile"><span>{props.componentData.durationSelection1Label.value}</span><span>{props.currentMonthCycle.periodDuration}</span></div>
                <div className="cycle-length-mobile"><span>{props.componentData.durationSelection2Label.value}</span><span>{props.currentMonthCycle.cycleLength}</span></div>
                <button onClick={showMainMenu}>
                    <img src={`${configData.sitecoreApiHost}${props.parentCompData.editLogo.value.src}`} />
                </button>
            </div>} */}
            <div className="container">
                <Pagination items={initialCalenderItems}
                    onChangePage={onChangePage}
                    componentData={props.componentData}
                    parentCompData={props.parentCompData}
                    checkSymptomps={checkSymptomps}
                />
                <div className="period-calculator-result">
                    {
                        pageOfItems.map((item, index) =>
                            // selectedDate={`${item.monthName} ${item.year}`}
                            <Calendar key={index} selectedDate={new Date(`${item.year}`, `${item.monthIndex - 1}`, `01`)}
                                dateModel={item.dates} getSymtopms={(day, dateModel, month, year) => getSymtopms(day, dateModel, month, year)}
                                currentYear={item.year} currentMonth={item.monthIndex - 1} legends={props.result.legends}
                            />
                        )
                    }

                </div>
            </div>
            <div className="label-container">
                {props.result.legends.map((item, index) => {
                    return (
                        <div className={(props.selectedTrack === 'PERIOD' || props.selectedTrack === 'FERTILE' || props.selectedTrack === 'OVULATION') ? 'only-period period-days' : 'period-days'} key={`${item}-${index}`}>
                            <span className='period-days-before' style={{ 'background': item.colorCode }}></span>
                            {item.title}
                        </div>
                    )
                })}
            </div>

            {/* {showSymptoms && <Symptoms selectedDay={selectedDay} componentData={props.componentData} />} */}
            {/* <p>This is selected Day - {selectedDay}</p> */}

        </>
    );
}

export default withTranslation()(SetRemindersPaginator);
